import {RoomEvent, Track, type LocalTrackPublication, type Room} from 'livekit-client';
import logger from '../../../services/logger';
import {describeLocalAudioTrack} from '../../../utilis/localTrackSettings';

type MicrophoneTrigger = 'current' | 'published' | 'audioinput' | 'audiooutput';

const logMicrophoneProcessing = (room: Room, trigger: MicrophoneTrigger): void => {
    const track = room.localParticipant.getTrackPublication(Track.Source.Microphone)?.track;
    if (!track) {
        return;
    }
    logger.info('Group call microphone processing', {
        source: 'group_call',
        event: 'microphone_processing',
        trigger,
        audioOutputDevice: room.getActiveDevice('audiooutput') ?? 'default',
        ...describeLocalAudioTrack(track.mediaStreamTrack),
    });
};

export const watchMicrophoneProcessing = (room: Room): (() => void) => {
    const onPublished = (publication: LocalTrackPublication) => {
        if (publication.source === Track.Source.Microphone) {
            logMicrophoneProcessing(room, 'published');
        }
    };
    const onDeviceChanged = (kind: MediaDeviceKind) => {
        if (kind === 'audioinput' || kind === 'audiooutput') {
            logMicrophoneProcessing(room, kind);
        }
    };
    logMicrophoneProcessing(room, 'current');
    room.on(RoomEvent.LocalTrackPublished, onPublished);
    room.on(RoomEvent.ActiveDeviceChanged, onDeviceChanged);
    return () => {
        room.off(RoomEvent.LocalTrackPublished, onPublished);
        room.off(RoomEvent.ActiveDeviceChanged, onDeviceChanged);
    };
};
